
/**
 * Module dependencies.
 */

import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslate } from './use-translate';
import cookies from 'browser-cookies';
import qs from 'qs';

/**
 * `Props` type.
 */

type Props = {
  domain?: string;
  languages: Array<string>;
};

/**
 * Export `LocaleSyncer` component.
 */

export function LocaleSyncer(props: Props): null {
  const { domain, languages } = props;
  const { i18n } = useTranslate();
  const locale = i18n.language;
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const cookieLocale = cookies.get('locale');

    if (cookieLocale !== locale) {
      cookies.set('locale', locale, { domain });
    }
  }, [domain, locale]);

  useEffect(() => {
    const { search, state } = location;
    const queryParameters = qs.parse(search, { ignoreQueryPrefix: true });
    const { locale: localeParam, ...restQuery } = queryParameters;

    if (languages.length > 1) {
      if (locale !== localeParam) {
        // Set the locale query param to match the app's language.
        history.replace({
          search: qs.stringify({
            ...restQuery,
            locale
          }),
          state
        });
      }
    } else if (locale) {
      // Remove the locale query param when there is only one language.
      history.replace({
        search: qs.stringify(restQuery),
        state
      });
    }
  }, [history, locale, languages, location]);

  return null;
}
